<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";
import { openUiChanges } from "@/stores/UiChangesState";

/**
 * Bouton « L'interface évolue », en haut du volet Paramètres : plus voyant
 * que les autres réglages (teinte et liseré de la couleur active).
 */
</script>

<template>
  <button
    type="button"
    class="ui-changes-banner"
    @click="openUiChanges('settings')"
  >
    <span class="banner-icon">
      <PhosphorIcon name="sparkle" :size="20" weight="fill" />
    </span>
    <span class="banner-body">
      <span class="banner-title">{{
        $t("canvas:uiChanges.banner.title")
      }}</span>
      <span class="banner-desc">{{ $t("canvas:uiChanges.banner.desc") }}</span>
    </span>
    <PhosphorIcon name="caret-right" :size="16" class="banner-caret" />
  </button>
</template>

<style lang="scss" scoped>
.ui-changes-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border: 1px solid var(--canvas-btn-mode-border);
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    var(--canvas-btn-mode-bg),
    rgba(255, 255, 255, 0.02)
  );
  color: #fff;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: var(--canvas-btn-hover-bg);
  }
}

.banner-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background-color: var(--canvas-btn-active-bg);
  color: #1a1a1a;
}

.banner-body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
}

.banner-title {
  font-size: 14px;
  font-weight: 700;
}

.banner-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.banner-caret {
  flex-shrink: 0;
  color: var(--canvas-btn-active-bg);
}
</style>
